module.exports = __webpack_public_path__ + "static/media/unwt.7dd0b3d1.JPG";